// import { QueryCache, QueryClient } from '@tanstack/react-query'

export const apiURL = "https://dev.royal.network/api";
// export const apiURL = "http://192.168.1.8:5000/api";

async function client(
  endpoint,
  { data, headers: customHeaders, ...customConfig } = {}
) {
  const token = localStorage?.getItem("accessToken");

  const config = {
    method: data ? "POST" : "GET",
    body: data instanceof FormData ? data : JSON.stringify(data),
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      ...(!data || data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...customHeaders,
    },
    ...customConfig,
  };

  try {
    const response = await window.fetch(`${apiURL}/${endpoint}`, config);
    // const clonedResponse = response.clone() // Clone to avoid "body already read" error

    const contentType = response.headers.get("Content-Type");
    if (contentType?.includes("text/csv")) {
      const data = await response.text();
      return data;
    }

    const jsonData = await response.json();

    if (response.ok) {
      return jsonData;
    } else {
      // Return a rejected promise with the error message
      return Promise.reject(
        new Error(
          jsonData.message || `HTTP ${response.status}: ${response.statusText}`
        )
      );
    }
  } catch (error) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("Network error occurred"));
  }
}

export { client };
